export default __webpack_public_path__ + "static/media/case-study-3-digital-devonport.d151d07e.mp4";